import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoDatePicker,
    RaikoGridOneColumn, RaikoGridThreeColumn,
    RaikoGridTwoColumn, RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    RaikoToggleOutlined,
    showServerErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {CampaignsService} from "../../../serverService/campaigns/CampaignsService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function CampaignBasicInfo({campaignId}) {

    const [title, setTitle] = useState("");
    const [rules, setRules] = useState("");
    const [description, setDescription] = useState("");
    const [slug, setSlug] = useState("");
    const [buttonLoading, setButtonLoading] = useState(false)
    const [buttonUpdateLoading, setButtonUpdateLoading] = useState(false)
    const [buttonLimitUpdateLoading, setButtonLimitUpdateLoading] = useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [automaticAcceptance, setAutomaticAcceptance] = useState(false);
    const [acceptance, setAcceptance] = useState(false);
    const [enabled, setEnabled] = useState(false);
    const [limitAmount, setLimitAmount] = useState(0)

    const service = new CampaignsService();

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getCampaignBasicInfoFromServer()
            getCampaignPeriodFromServer()
            getAdmissionSettingsFromServer()
        }
    }, []);

    function getCampaignBasicInfoFromServer() {
        loading.show()
        service.getCampaignBasicInfo(campaignId)
            .then(
                response => {
                    setTitle(response.title ? response.title : "-")
                    setSlug(response.slug ? response.slug : "-")
                    setDescription(response.description ? response.description : "-")
                    setRules(response.rules ? response.rules : "-")
                }
            ).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateCampaignBasicInfo() {
        setButtonLoading(true)
        service.updateCampaignBasicInfo(campaignId, title, slug, description, rules)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setButtonLoading(false)
        })
    }


    function getCampaignPeriodFromServer() {
        loading.show()
        service.getCampaignPeriod(campaignId)
            .then(response => {
                setStartDate(convertUniversalDateToPersianDate(response.from))
                setEndDate(convertUniversalDateToPersianDate(response.to))
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateCampaignPeriod() {
        setButtonUpdateLoading(true)
        service.updateCampaignPeriod(campaignId, startDate, endDate)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setButtonUpdateLoading(false)
        })

    }

    function getAdmissionSettingsFromServer() {
        loading.show()
        service.getAdmissionSettings(campaignId)
            .then(response=>{
                setAcceptance(response.acceptance)
                setAutomaticAcceptance(response.automaticAcceptance)
                setEnabled(response.enabled)
                setLimitAmount(response.maximumNumberOfRegistrationsAllowed)
            }).catch(reason => {
                showServerErrorMessage(reason)
        }).finally(_=>{
            loading.hide()
        })

    }

    function handleUpdateAdmissionSettings() {
        setButtonLimitUpdateLoading(true)
        service.updateAdmissionSettings(campaignId,automaticAcceptance,acceptance,enabled,limitAmount)
            .then(response=>{
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                showServerErrorMessage(reason)
        }).finally(_=>{
            setButtonLimitUpdateLoading(false)
        })
    }


    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonLoadingState={buttonLoading}
                    actionButtonOnclick={handleUpdateCampaignBasicInfo}
                >
                    <RaikoGridOneColumn>
                        <RaikoGridTwoColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"عنوان پویش"}
                                value={title}
                                setValue={setTitle}
                            />
                            <RaikoSimpleInputOutlined
                                labelText={"slug"}
                                value={slug}
                                setValue={setSlug}
                            />

                        </RaikoGridTwoColumn>
                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"توضیحات"}
                            setValue={setDescription}
                            multiline={true}
                            row={10}
                            value={description}
                        />
                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"قوانین"}
                            setValue={setRules}
                            multiline={true}
                            row={10}
                            value={rules}
                        />
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"دوره زمانی"}
                    hasActionButton
                    actionButtonLoadingState={buttonUpdateLoading}
                    actionButtonOnclickWithValidation={
                        handleUpdateCampaignPeriod
                    }
                >
                    <RaikoGridTwoColumn>
                        <RaikoDatePicker
                            label={"تاریخ شروع"}
                            date={startDate}
                            setDate={setStartDate}
                            required
                        />
                        <RaikoDatePicker
                            label={"تاریخ پایان"}
                            date={endDate}
                            setDate={setEndDate}
                            required
                        />
                    </RaikoGridTwoColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"تنظیمات پذیرش"}
                    hasActionButton
                    actionButtonOnclick={handleUpdateAdmissionSettings}
                    actionButtonLoadingState={buttonLimitUpdateLoading}
                >
                    <RaikoGridOneColumn>
                        <RaikoGridThreeColumn>
                            <RaikoToggleOutlined
                                labelText={"فعالسازی"}
                                setChecked={state => {
                                    setEnabled(state)
                                }}
                                id={"checkHabitationAuto"}
                                checked={enabled}
                            />
                            <RaikoToggleOutlined
                                labelText={"محدودیت بررسی درخواست ها"}
                                setChecked={state => {
                                    setAcceptance(state)
                                }}
                                id={"checkHabitationAuto"}
                                checked={acceptance}
                            />
                            <RaikoToggleOutlined
                                labelText={"فعالسازی بررسی خودکار درخواست ها"}
                                setChecked={state => {
                                    setAutomaticAcceptance(state)
                                }}
                                id={"checkHabitationAuto"}
                                checked={automaticAcceptance}
                            />
                        </RaikoGridThreeColumn>
                        <RaikoNumberInputOutlined labelText={"حداکثر تعداد ثبت نام مجاز"} value={limitAmount}
                                                  setValue={setLimitAmount}/>
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}